import React from 'react';
import { CdsContentPanel } from 'clayco-component-library';

// Copy of StayBenefitPolicyPanel with adjusted titles.
const HouseholdItemsPolicyPanel = ({ successMessage, isLoading, loadError, onAdd, children }) => (
  <CdsContentPanel
    title={<span>Household Goods Provisional Sum Application Form</span>}
    collapsible={false}
    primaryButtonText="Add Allowance Request"
    primaryButtonSubmits={false}
    primaryButtonHandler={onAdd}
  >
    <div className="mb-3">
  <p>
    When you relocate cities for a project assignment, Clayco provides support to help make your new living space comfortable and functional. Eligible employees may receive $1,500 to cover/offset the costs associated with household items purchased to furnish or set up and equip their temporary housing near the jobsite.  This is a one-time net payment.
  </p>
  <p>
    The Household Goods Provisional Sum is intended to cover the types of items listed below — these items should not be expensed elsewhere through Concur or other reimbursement systems.
  </p>
  <p>
    This benefit only applies to employees who are eligible for per diem.
  </p>
  <p>
    Requests must be submitted and approved by end of day Monday to be included in the current week&rsquo;s paycheck.
  </p>
  <p><strong><u>Example Eligible Items</u></strong></p>

  <p style={{ marginBottom: 0 }}><strong>Bedroom</strong></p>
  <p style={{ marginTop: 0 }}>Sheet Set, Pillow Set, Mattress Topper, Comforter, Hangers, etc.</p>

  <p style={{ marginBottom: 0 }}><strong>Bathroom</strong></p>
  <p style={{ marginTop: 0 }}>Towels, Shower Curtain, Bathroom Accessories Set, Plunger, etc.</p>

  <p style={{ marginBottom: 0 }}><strong>Living Room</strong></p>
  <p style={{ marginTop: 0 }}>TV / Monitor</p>

  <p style={{ marginBottom: 0 }}><strong>Kitchen</strong></p>
  <p style={{ marginTop: 0 }}>Dinnerware Set, Utensils, Cookware Set, Cooking Utensils Set, Knife Set, Toaster, Coffee Maker, Paper Towel Holder, Trash Can, Microwave, etc.</p>

  <p style={{ marginBottom: 0 }}><strong>Cleaning &amp; Supplies</strong></p>
  <p style={{ marginTop: 0 }}>Vacuum, Mop & Bucket Set, Cleaning Supply Starter Kit, Trash Can Liners, Dishwasher Detergent, Laundry Detergent, Dryer Sheets, Toilet Paper, Paper Towels, Soap, Fire Extinguisher (Kitchen), First Aid Kit, Household Tool Kit, etc.</p>
</div>
    {successMessage && <div className="alert alert-success py-2" role="alert">{successMessage}</div>}
    {isLoading && <div className="small text-muted">Loading submissions...</div>}
    {loadError && <div className="alert alert-danger py-2" role="alert">{loadError}</div>}
    {children}
  </CdsContentPanel>
);

export default HouseholdItemsPolicyPanel;
